export enum FeeStatus {
    Pending = 'pending',
    Ready = 'ready',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Refunded = 'refunded',
    PartiallyRefunded = 'partially-refunded',
    Disputed = 'disputed',
    Canceled = 'canceled',
}
